
export default {
    name: 'visualizer',
    data () {
        return {
          Display:'0px',
          Opacity: 0,
          position: '0',
          transition: 'left 0.3s',
          startPoint: 0,
          prevPositon: 0,
          min: -100,
          offset:100,
          lastTapTime:0,
          ImgWidthM:'100%',
          ImgWidth:'auto',
          DisplayDesc:true,
          infos:{},
          description:'',
          elts:[/*{img:'chambre.jpg'},{img:'phone.svg'},{img:'star.svg'},{img:'quote.svg'}*/]
        }
    },
    computed: {
      Position () {
        return this.position+'%'
      }
    },
    methods: {
      resetZoom () {
        this.ImgWidth = 'auto'
        this.ImgWidthM = '100%'
      },
      dragStart (event) {
        
        /*if (event.touches.length === 2) {
          let e = event
          this.pinchDistance = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
          //console.log('Début du zoom : distance = ' + distance);
        } */
        //-------- double tap detection system -------------
        if(event.type == 'touchstart') {
          const currentTime = new Date().getTime();
          if (currentTime - this.lastTapTime < 300) {
            this.ImgWidth = this.ImgWidth == 'auto' ? '180%' : 'auto'
            this.ImgWidthM = this.ImgWidthM == '100%' ? '180%' : '100%'
          }
          else this.lastTapTime = currentTime;
        }
        //event.preventDefault()
        if(this.ImgWidth != "auto" ) return // not the time to slide

        this.startPoint = event.type == 'touchstart' ? event.touches[0].pageX : event.pageX
        this.prevPositon = this.position
      },
      dragging (event) {
        /*if (event.touches.length === 2) {
          let e = event
          let distance1 = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
          let width = this.ImgWidth == 'auto' ? 0 : this.ImgWidth.slice(0,-1)
          width =  parseInt(parseInt(width) + (distance1 - this.pinchDistance)/2)
          if(width <= 60) {
            this.ImgWidth = 'auto'
            this.ImgWidthM = '100%'
          }
          else if (width > 400) {
            this.ImgWidth = '400%'
            this.ImgWidthM = '400%'
            //this.pinchDistance = distance1
          }
          else {
            this.ImgWidth = width+'%'
            this.ImgWidthM = width+'%'
          }
          this.pinchDistance = distance1
          this.description = this.ImgWidth
        }*/
        
        if(this.startPoint != 0) {
          let offset = event.type == 'touchmove' ? event.touches[0].pageX : event.pageX
          //alert(offset)
          //------------------------------------------------------------
          let a = offset - this.startPoint
          a = a/window.innerWidth*60
          let newPosition = parseFloat(this.position) + a
          if(newPosition >= this.min && newPosition <= 0) this.position = newPosition
        }
      },
      dragEnd () {
        let dragDistance = this.prevPositon - this.position
        //------ multiplicateur --------------------------
        let m = 1
        if(Math.abs(dragDistance) > 140 ) m = 2
        else if(Math.abs(dragDistance) > 200 ) m = 3
        else if(Math.abs(dragDistance) > 230 ) m = 4

        let r = this.prevPositon
        if( dragDistance < 0 ) r = this.prevPositon + m*this.offset
        else if(dragDistance > 0) r = this.prevPositon - m*this.offset

        if(r <= this.min) this.position = this.min
        else if(r >= 0) this.position = 0
        else this.position = r - r%this.offset
        this.startPoint = 0
      },
      toWhatsapp () {
        window.open(`https://wa.me/+237${this.infos.whatsappTel}?text=Hello ! Je suis intéressé par *${this.infos.nomProduit}*.
        `)
      },
      close () {
        this.elts = []
        this.Display = '0px'
        this.Opacity = 0
        this.position = '0'
        this.startPoint = 0
        this.prevPositon = 0
        this.DisplayDesc = true
        this.resetZoom()
      },
      open (images,infos) {
        if(images.length == 0) return
        this.infos = infos
        this.elts = images
        this.min = -this.elts.length*100 + 100
        this.Display = "100%"
        this.Opacity = 1
        this.description = infos.prodDescription == null || infos.prodDescription == 'null' ? '': infos.prodDescription
      }
    }
}

//:class="(ImgWidth == 'auto' || ImgWidth.slice(0,-1) < 100) ? 'visualCenter' : 'visualStart'"